
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import RadioButton from '@/components/radio-button.vue';
  import Dialog from '@/components/dialog.vue';
	import Message from '@/components/message.vue';
  import {
    getExpressList,
  } from '@/api/logistics';
  import {
    productSendorderDetailList,
    productSendsend,
    productSendsendReturn
  } from '@/api/order';
import { nextDay } from '@/utils';
  @Component({  
    name: '',
    components: {
      PageFooter,
      RadioButton,
      'slz-dialog': Dialog,
			'slz-message': Message,
    }
  })

  export default class ProductList extends Vue {
    private radioType = 0
    private radioList = [
      {value:0,label:'未发货'},
      {value:1,label:'已发货'},
    ]
    private keywords = ''
    private tablelist:any = [{}]
    private tableloading = false
		private pageNo = 1;
		private pageSize = 10;
		private total = 0;

    private showImportExel = false
    private dialogType = 0;
    private expressList: any = [];
    private currentOrder:any = {};
    private form: any = [{
      ExpressId:'',
      ExpressValue:'',
      ExpressNo:''
    }]

    private rowmsg:any = {}
    private returnShow = false

    private mounted () {
      // console.log(this.$route.query.filterTime)
      this.gettablelist()
    }


    private async confirmreturn(){
      this.tableloading = true
      try{
        let res:any = await productSendsendReturn({
          OrderNo:this.rowmsg.OrderNo,
          OrderDetailId:this.rowmsg.OrderDetailId
        })
        if(res.IsSuccess){
          this.$message.success('已返回待发货')
          this.gettablelist()
        }
      }finally{
        this.tableloading = false
      }
    }
    private returnbeshipped(row){
      this.rowmsg = row
      this.returnShow = true
    }
    private delform(e){
      this.form.splice(e,1)
    }
    /**
     * 物流公司
     */
    private async getExpressList() {
      try {
        const res: any = await getExpressList({});
        this.expressList = res.Result || [];
      } catch (e) {
        console.log(e)
      }
    }
    private showLogistics(type: number, row ? : any) {
      this.showImportExel = true;
      this.dialogType = type;
      let list = [
        {
          ExpressId:'',
          ExpressValue:'',
          ExpressNo:''
        }
      ]
      this.form = JSON.parse(JSON.stringify(row.ExpressBasicInfoList&&row.ExpressBasicInfoList.length?row.ExpressBasicInfoList:list))
      this.currentOrder = row;
      this.getExpressList()
    }
    private async confirmInvoice(){
      if(!this.form||!this.form.length){
        this.$message.error('至少有一个快递单号')
        return
      }
      for(let item of this.form){
        if (item.ExpressId !== 37){
          if(!item.ExpressId || !item.ExpressNo){
            this.$message.error('请填写物流信息')
            return
          }
        }
      }
      
      try{
        let data: any = {
          OrderNo: this.currentOrder.OrderNo,
          OrderDetailId: this.currentOrder.OrderDetailId,
          ExpressBasicInfoList:this.form
        }
        let res = await productSendsend(data)
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.handleCloseImport()
          this.gettablelist()
        }

      }finally{

      }
    }
    private newpush(){
      this.form.push({
        ExpressId:'',
        ExpressValue:'',
        ExpressNo:''
      })
    }
    private handleCloseImport(){
      this.showImportExel = false
      this.form = []
    }
    private changetype(e){
      this.doSearch()
      this.$nextTick(()=>{
        (this as any).$refs.table.doLayout()
      })
    }
    private doSearch(){
      this.pageNo = 1
      this.gettablelist()
    }
    private clearSearch(){
      this.keywords = ''
      this.doSearch()
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any = {
          SendState:this.radioType,
          ProductId:this.$route.query.Id,
          ProviderId:this.$route.query.ProviderId,
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if (this.$route.query.filterTime) {
          var dt = String(this.$route.query.filterTime).split('/');
          data.StartTime = dt[0]
          data.EndTime = nextDay(dt[1],1)
        }
        let res = await productSendorderDetailList(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            v.Expressmsg = v.ExpressBasicInfoList.map(x=>x.ExpressValue+' '+x.ExpressNo).join(';')
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
  }
